import { render, staticRenderFns } from "./PayReceiptPopup.vue?vue&type=template&id=6874d23e&"
import script from "./PayReceiptPopup.vue?vue&type=script&lang=js&"
export * from "./PayReceiptPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports